import { apiClient } from "../common/axiosInstance";
import { handleAxiosError } from "../common/handleAxiosError";
import { ISenioritiesResponse } from "./types";

export const getAllSeniority = async (): Promise<ISenioritiesResponse> => {

  try {
    const response = await apiClient.get("/seniority");
    return response.data;
  } catch (error) {
    handleAxiosError(error, "Error fetching seniority");
    throw error;
  }
};
